import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {Club, Customer, ReservationTicket} from '~core/models';
import {DefaultNotificationService, InvoiceService, StorageService} from '~core/services';
import {NotificationType} from "~core/enum";
import {HttpErrorResponse} from "@angular/common/http";

/**
 * Ticketing component that decides what tab to display
 */
@UntilDestroy()
@Component({
  selector: 'app-ticketing',
  templateUrl: './ticketing.component.html',
  styleUrls: ['../../customer-overview.component.scss']
})
export class TicketingComponent implements OnInit, OnDestroy {
  public currentlyOpened: string = 'invoices';
  public reservationList: Array<ReservationTicket> = [];
  public bookableReservations: number = 0;
  public selectedClub: Club;
  public i18nTixxReservationsTimeout = $localize`:@@notification.warning.tixxReservationTimeout:Tixx Reservations for this customer can't be displayed as there are too many. Please visit the customer profile in Tixx to see all reservations.`;
  public tixxReservationsTimedOut: boolean = false;
  @Input() public customer: Customer;
  @Input() public isPanelOpened: boolean = true;
  @Output() public isPanelOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public customerService: CustomerOverViewService,
    private storageService: StorageService,
    private invoiceService: InvoiceService,
    private notificationService: DefaultNotificationService
  ) {
    this.invoiceService.castReservationsList.pipe(untilDestroyed(this))
      .subscribe(data => this.reservationList = data);
    this.invoiceService.castNumberOfReservations.pipe(untilDestroyed(this)).subscribe(value => this.bookableReservations = value);
    this.storageService.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
  }

  public ngOnInit(): void {
    if (!this.selectedClub.isDataFeedActive) {
      this.invoiceService.getCustomerReservations(this.customer.id).pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.invoiceService.setReservationsList(res);
          },
          error: (error: HttpErrorResponse) => {
            this.invoiceService.setReservationsList([]);
            if (error.status === 504 || error.error['hydra:description'] === 'TIXX_API_TIMEOUT') {
              this.tixxReservationsTimedOut = true;
              this.notificationService.showNotification({
                type: NotificationType.WARNING,
                message: this.i18nTixxReservationsTimeout
              });
            }
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.invoiceService.setInvoiceList(null);
    this.invoiceService.setCancellationsList(null);
    this.invoiceService.setReservationsList(null);
    this.invoiceService.setNumberOfReservations(0);
  }

  /**
   * Sets the currently opened tab
   */
  setCurrentlyOpened(tab: string): void {
    this.currentlyOpened = tab;
  }

  /**
   * Check if the type is currently opened
   */
  isCurrentlyOpened(type: string): boolean {
    if (this.currentlyOpened !== null) {
      return this.currentlyOpened === type;
    }
  }
}
